import { useEffect, useState } from "react";
import Admindashboard from "./Admindashboard";
import Header from "./Header";
import AdminSidebar from "./Sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import LiveAccessListener from "./LiveAccessListener";

const Layout = () => {
  const isMobile = useIsMobile();
  const [defaultOpen, setDefaultOpen] = useState(true);

  useEffect(() => {
    // Set sidebar to closed by default on mobile
    setDefaultOpen(!isMobile);
  }, [isMobile]);

  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <LiveAccessListener />
      <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
        {/* Sidebar section */}
        <AdminSidebar onSectionChange={() => {}} />

        {/* Main content area */}
        <div className="flex flex-col flex-1 h-full">
          <Header />
          <main className="flex-1 overflow-y-auto p-3 sm:p-6">
            <Admindashboard />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Layout;
